import React, { useEffect, useRef, useState } from "react"
import DebouncedInput from "./DebouncedInput"
import { Overlay } from "react-bootstrap"
import { useOutsideAlerter } from "./useOutsideAlerter"
import dayjs from "dayjs"

const NumberInput = ({
  columnFilterValue,
  getFacetedMinMaxValues,
  setFilterValue
}) => {
  const minOpt = getFacetedMinMaxValues()?.[0]
  const min = Number(minOpt ?? "")

  const maxOpt = getFacetedMinMaxValues()?.[1]
  const max = Number(maxOpt)

  return (
    <div>
      <div className="d-flex">
        <DebouncedInput
          type="number"
          min={min}
          max={max}
          value={columnFilterValue?.[0] ?? ""}
          onChange={value =>setFilterValue(old => [value, old?.[1]])}
          placeholder={`Min ${minOpt ? `(${min})` : ""}`}
          className="form-control form-control-sm me-2"
        />
        <DebouncedInput
          type="number"
          min={min}
          max={max}
          value={columnFilterValue?.[1] ?? ""}
          onChange={value => setFilterValue(old => [old?.[0], value])}
          placeholder={`Max ${maxOpt ? `(${max})` : ""}`}
          className="form-control form-control-sm"
        />
      </div>
      <button
        type="button"
        className="btn btn-primary btn-wide btn-sm w-100 mt-2"
        onClick={() => {
          setFilterValue(undefined)
        }}
      >
        Reset
      </button>
    </div>
  )
}

const TextInput = ({
  columnFilterValue,
  columnSize,
  setFilterValue,
  sortedUniqueValues
}) => {
  const [constraint, setConstraint] = useState("")

  return (
    <React.Fragment>
      <DebouncedInput
        type="text"
        value={constraint ?? ""}
        onChange={value => setConstraint(`${value}`)}
        placeholder={`Search... (${columnSize})`}
        className="form-control form-control-sm"
      />
      <ul
        className="p-0 mt-2"
        style={{
          overflow: "auto",
          maxHeight: "250px"
        }}
      >
        {sortedUniqueValues
          .filter(v => v?.toLowerCase().includes(constraint.toLowerCase()))
          .slice(0, 20)
          .map((value,i) => (
            <li
              className="py-1"
              style={{
                listStyle: "none"
              }}
              key={i}
            >
              <label className="m-0">
                <input
                  type="checkbox"
                  className="me-2 mr-2"
                  name="dropdown-group"
                  onChange={e => {
                    if (e.target.checked)
                      setFilterValue([...(columnFilterValue ?? []), value])
                    else
                      setFilterValue(
                        (columnFilterValue ?? []).filter(v => v !== value)
                          .length
                          ? (columnFilterValue ?? []).filter(v => v !== value)
                          : undefined
                      )
                  }}
                  value={value}
                  checked={(columnFilterValue ?? []).includes(value)}
                />
                {value}
              </label>
            </li>
          ))}
      </ul>
      <button
        type="button"
        className="btn btn-primary btn-wide btn-sm"
        onClick={() => {
          setFilterValue(undefined)
        }}
      >
        Reset
      </button>
    </React.Fragment>
  )
}

const DateRangeInput = props => {
  const [dateRange, setDateRange] = useState([
    props.columnFilterValue?.[0]
      ? dayjs(props.columnFilterValue?.[0])
      : undefined,
    props.columnFilterValue?.[1]
      ? dayjs(props.columnFilterValue?.[1])
      : undefined
  ])

  useEffect(() => {
    setDateRange([
      props.columnFilterValue?.[0]
        ? dayjs(props.columnFilterValue?.[0])
        : undefined,
      props.columnFilterValue?.[1]
        ? dayjs(props.columnFilterValue?.[1])
        : undefined
    ])
  }, [props.columnFilterValue])

  return (
    <div>
      <div className="d-flex">
        <DebouncedInput
          type="date"
          onChange={e => {
            props.setFilterValue([
              e ? dayjs(e, "YYYY-MM-DD").toDate() : undefined,
              dateRange[1]?.toDate()
            ])
          }}
          value={dateRange[0]?.format("YYYY-MM-DD") ?? ""}
          className="form-control form-control-sm"
        />
        <DebouncedInput
          type="date"
          onChange={e => {
            props.setFilterValue([
              dateRange[0]?.toDate(),
              e ? dayjs(e, "YYYY-MM-DD").toDate() : undefined
            ])
          }}
          value={dateRange[1]?.format("YYYY-MM-DD") ?? ""}
          className="form-control form-control-sm"
        />
      </div>
      <button
          type="button"
        className="btn btn-primary btn-wide w-100 mt-2"
        onClick={() => props.setFilterValue([undefined, undefined])}
      >
        Resetear Filtro
      </button>
    </div>
  )
}

const BooleanFilter = props => {
  return (
    <div>
      <div>
        <label className="kt-checkbox" style={{ fontSize: '12px' }}>
          <input
            type="checkbox"
            className="form-control"
            name={"markTrue"}
            checked={props.columnFilterValue === 'true' || !props.columnFilterValue} onChange={(e)=>{
              if(props.columnFilterValue === 'true') props.setFilterValue(undefined)
              if(props.columnFilterValue === 'false') props.setFilterValue(undefined)
              if(!props.columnFilterValue) props.setFilterValue('false')
            }}
          />
          <span></span>
          <label className="ms-1">Seleccionados</label>
        </label>
      </div>
      <div>
          
        <label className="kt-checkbox" style={{ fontSize: '12px' }}>
          <input
            type="checkbox"
            className="form-control"
            name={"markFalse"}
            checked={props.columnFilterValue === 'false' || !props.columnFilterValue} onChange={(e)=>{
              if(props.columnFilterValue === 'true') props.setFilterValue(undefined)
              if(props.columnFilterValue === 'false') props.setFilterValue(undefined)
              if(!props.columnFilterValue) props.setFilterValue('true')
            }}
          />
          <span></span>
          <label className="ms-1">No Seleccionados</label>
        </label>
      </div>
      <button
        type="button"
        className="btn btn-label-brand btn-bold w-100"
        style={{ fontSize: '12px' }}
        onClick={() => props.setFilterValue(undefined)}
      >
        Resetear Filtro
      </button>
    </div>
  )
}

export const NumberFinderFilter = props=>{
  return (
    <div>
      <div className="my-2">
        <input type="text" value={props.columnFilterValue} autoComplete="false" onChange={e=>props.setFilterValue(e.target.value)}/>
      </div>
      <button
          type="button"
        className="btn btn-primary btn-wide w-100 mt-2"
        onClick={() => props.setFilterValue(undefined)}
      >
        Resetear Filtro
      </button>
    </div>
  )
}

export function Filter({ column, table }) {
  const firstValue = table
    .getPreFilteredRowModel()
    .flatRows[0]?.getValue(column.id)

  const columnFilterValue = column.getFilterValue()
  const uniqueValues = column.getFacetedUniqueValues()

  const sortedUniqueValues = React.useMemo(
    () =>
      typeof firstValue === "number"
        ? []
        : Array.from(uniqueValues.keys()).sort(),
    [uniqueValues]
  )

  if (column.columnDef.meta?.["filterType"] === "date-range-filter")
    return (
      <DateRangeInput
        columnFilterValue={columnFilterValue}
        columnId={column.id}
        setFilterValue={column.setFilterValue}
      />
    )

  if (column.columnDef.meta?.["filterType"] === 'number-finder')
      return (
        <NumberFinderFilter
          columnFilterValue={columnFilterValue}
          columnId={column.id}
          setFilterValue={column.setFilterValue}
        />
      )

  if(column.columnDef.meta?.['filterType'] === 'boolean-filter')
    return (
      <BooleanFilter
        columnFilterValue={columnFilterValue}
        columnId={column.id}
        setFilterValue={column.setFilterValue}
      />
    )

  if (column.columnDef.meta?.['filterType'] === 'number-filter')
    return (
      <NumberInput
        columnFilterValue={columnFilterValue}
        getFacetedMinMaxValues={column.getFacetedMinMaxValues}
        setFilterValue={column.setFilterValue}
      />
    )
  if (column.columnDef.meta?.['filterType'] === 'multi-list-filter')
    return (
      <TextInput
        columnId={column.id}
        columnFilterValue={columnFilterValue}
        columnSize={uniqueValues.size}
        setFilterValue={column.setFilterValue}
        sortedUniqueValues={sortedUniqueValues}
      />
    )
  return null
}

export function FilterOverlay(pprops) {
  const target = useRef(null)
  const [show, setShow] = useState(false)
  const sref = useRef(null)
  useOutsideAlerter(sref, () => {
    setShow(false)
  })
  return (
    <>
      <button
          type="button"
        ref={target}
        onClick={() => setShow(true)}
        className={
          "btn btn-sm me-1" +
          (pprops.column.getFilterValue() ? " btn-primary" : " btn-secondary")
        }
      >
        <i className="fas fa-filter" />
      </button>
      <Overlay target={target.current} show={show} placement="bottom-start">
        {({
          placement: _placement,
          arrowProps: _arrowProps,
          show: _show,
          popper: _popper,
          hasDoneInitialMeasure: _hasDoneInitialMeasure,
          ...props
        }) => {
          return (
            <div
              {...props}
              style={{
                position: "absolute",
                backgroundColor: "white",
                border: "1px solid #ccc",
                borderRadius: 3,
                marginTop: "5px",
                zIndex: 2000,
                ...props.style
              }}
            >
              <div
                className="d-flex flex-column"
                ref={sref}
                style={{ padding: "8px 10px" }}
              >
                <span className="h5" style={{ fontSize: '12px' }}>Filtrar</span>
                <Filter column={pprops.column} table={pprops.table} />
              </div>
            </div>
          )
        }}
      </Overlay>
    </>
  )
}

export default Filter
